import { TestComponentProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<TestComponentProps>
  ): React.FC<TestComponentProps> =>
  (props: TestComponentProps) => {
    return <Component {...props} />;
  };
